export default {
    items: {
        data: []
    },
}